import React from 'react';

export const PointIcon = () => {
    return (
        <svg
        style={{ filter: 'drop-shadow(#3452F4 0px 0px 7px)'}} 
        width="16" height="32" viewBox="0 0 16 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="32" rx="8" fill="#3452F4"/>
        </svg>
    )
}



